import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { CommonService } from 'src/app/services/common/common.service';
import { UserAuthService } from 'src/app/services/user-auth/user-auth.service';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
})
export class LogoutComponent implements OnInit {
  isLogin = false;
  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly userAuthSvc: UserAuthService,
    private readonly authService: MsalService
  ) {}

  ngOnInit(): void {
    this.userAuthSvc.checkLoginStatus().subscribe(() => {
      this.isLogin = this.authService.instance.getAllAccounts().length > 0;
      if (this.isLogin) {
        this.router.navigate([`../home`], { relativeTo: this.route });
      }
    });
  }
}
